import './Notfound.css';
import Button from '../../Button/button';
import BannerNotfoundHomePhone from '../../Banners/BannerNotfoundHomePhone/BannerNotfoundHomePhone.js'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import Loading from '../../Loading/Loading'

let button = document.querySelector(".continuar");
let spinnerButon = "continuar"

function Notfound() {
    const [isChecked, setIsChecked] = useState(true)
    const navigate = useNavigate();
    const [isShow, setShow] = useState(false);

    setTimeout(() => {
        //setShow(false);
    }, 1000);

    return (
        <div className="home">
            {isShow && <Loading />}
            <BannerNotfoundHomePhone />
            <form
                className='container2'>
                <div className='form'>
                    <div className='titleform3'>
                        <h4>Página Não Encontrada</h4>

                        <h1>Não foi possível encontrar a página. Favor iniciar o processo inicial clicanco no botão abaixo.</h1>
                    </div>
                    <div className='spaceform'></div>

                    <button
                            className={spinnerButon}
                            cursor='pointer'
                            onClick={() => navigate("/")}>
                            Ir para a página inicial
                        </button>
                </div>
            </form>
     
        </div>
    );
}

export default Notfound;